import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import CustomIcon from '../../common/CustomIcon';
import * as contentUtils from '../../../utils/contentUtils';
import { isElectronApp } from '../../../services/crossPlatform/crossPlatformService';
import { SmartButton } from '../../common/SmartButton';
import * as contentActions from '../../../actions/contentActions';
import * as customTranslate from '../../../services/translate/customTranslateService';
import * as bookActions from '../../../actions/bookActions';
import BookDownloadBar from '../../book/BookDownloadBar/BookDownloadBar';

class BookTitleBox extends Component {
  static propTypes = {
    task: PropTypes.any,
    book: PropTypes.any,
    classroomId: PropTypes.string,
    isAppOnline: PropTypes.bool,
    contentBooks: PropTypes.object,
    synchronizedClassrooms: PropTypes.array,
    language: PropTypes.string,
    classroom: PropTypes.object,
    contentActions: PropTypes.object,
    bookActions: PropTypes.object
  };

  canDownload = () => {
    const { isPreview, contentBooks, book, task } = this.props;
    const isBookDownloading = contentUtils.isStoreContentBookSaving(book, contentBooks);
    const isSynchronizing = contentUtils.isStoreContentBookSynchronizing(book, contentBooks);

    return (
      book &&
      Object.keys(book).length !== 0 &&
      !isPreview &&
      isElectronApp() &&
      !isBookDownloading &&
      !isSynchronizing &&
      task.bookActivityId
    );
  };

  handleDownloadButton = () => {
    const { book, contentActions, classroom, language } = this.props;
    const title = customTranslate.translateObject(book.name, language);
    contentActions.saveBook(classroom.id, book, title);
  };

  renderDownloadButton() {
    const { isAppOnline, contentBooks, book, synchronizedClassrooms } = this.props;
    const isBookDownloaded = contentUtils.isStoreContentBookDownloaded(book, contentBooks);
    const isSynchronized = synchronizedClassrooms.length > 1;

    if (this.canDownload() && !isBookDownloaded) {
      return (
        <SmartButton onClick={this.handleDownloadButton} disabled={isAppOnline} success={true}>
          <CustomIcon name="download-tray" size={15} />
          {' ' + I18n.t('common.option.download')}
        </SmartButton>
      );
    }
    return null;
  }

  handleReDownloadButton = () => {
    const { book, bookActions } = this.props;
    bookActions.setReDownloadBookState(book);
  };

  renderReDownloadButton() {
    const { isAppOnline, contentBooks, book, synchronizedClassrooms } = this.props;
    const isBookDownloaded = contentUtils.isStoreContentBookDownloaded(book, contentBooks);
    const isSynchronized = synchronizedClassrooms.length > 1;

    if (this.canDownload() && isBookDownloaded) {
      return (
        <SmartButton onClick={this.handleReDownloadButton} disabled={isAppOnline} success={true}>
          <CustomIcon name="download-tray" size={15} />
          {' ' + I18n.t('common.option.reDownload')}
        </SmartButton>
      );
    }
    return null;
  }

  render() {
    const { book, classroomId } = this.props;
    return (
      <>
        <div className="book-title-box-container">
          <div className="book-title-box-title">{Object.values(book.name)[0]}</div>
          <div className="button-container">
            {this.renderDownloadButton()}
            {this.renderReDownloadButton()}
          </div>
        </div>
        <BookDownloadBar bookId={book.id} classId={classroomId} />
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    book: state.book.book,
    language: state.account.user.language,
    contentBooks: state.content.contentBooks,
    synchronizedClassrooms: state.book.synchronizedClassrooms,
    classroom: state.classrooms.activeClassrooms.find(c => c.id === state.task.selectedTask.parentSection)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    contentActions: bindActionCreators(contentActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookTitleBox);
